<div>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>

  <p-dialog [(visible)]="configMissing" [closable]="false" appendTo="self">
    <i style="font-size: 10px" class="pi pi-exclamation-circle pr-1"></i> <label>Well Configuration Missing: Please specify at least one string</label>
    <br />
    <br />
  </p-dialog>

  <p-dialog [draggable]="false" [visible]="glvErrorMessage != null" [closable]="false" appendTo="self">
      <i style="font-size: 10px" class="pi pi-exclamation-circle pr-1"></i> <label>{{ glvErrorMessage }}</label>
      <br />
      <br />
    </p-dialog>

  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

    <form [formGroup]="gasLiftValvesForm" novalidate>
      <ng-container formArrayName="gasLiftValves">
        <p-table
          [appAutoTableHeight]="true"
          [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
          [appAutoTableHeightOffset]="62"
          (appAutoTableHeightChange)="tableHeight = $event"
          [scrollable]="true"
          [scrollHeight]="tableHeight"
          showGridlines
          [columns]="columnDefs"
          [resizableColumns]="true"
          [value]="gasLiftValves.controls"
          dataKey="value.id"
          stateStorage="local"
          showGridlines
          [stateKey]="componentId"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track $index) {
              <th class="text-center" pResizableColumn>
                {{ col.header }}
              </th>
              }
              <th class="text-center">
                <p-button
                  size="small"
                  class="outlined-button"
                  severity="success"
                  icon="pi pi-plus"
                  outlined="true"
                  [disabled]="configMissing || gasLiftValves.invalid"
                  (click)="onAddGlv()"
                ></p-button>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-gasLiftValveFg let-rIdx="rowIndex">
            <ng-container [formGroupName]="rIdx">
              <tr>
                <td>
                  <input pInputText formControlName="name" title="Name" style="width: 95%"/>
                  <app-validation-error
                    [isValid]="isControlInvalid(gasLiftValveFg, 'name')"
                    [errorMsg]="getControlErrors(gasLiftValveFg, 'name')"
                  />
                </td>
                <td>
                  <p-inputNumber
                    class="w-full"
                    formControlName="measuredDepth"
                    [minFractionDigits]="1"
                    title="Depth"
                  ></p-inputNumber>
                  <app-validation-error
                    [isValid]="isControlInvalid(gasLiftValveFg, 'measuredDepth')"
                    [errorMsg]="getControlErrors(gasLiftValveFg, 'measuredDepth')"
                  />
                </td>

                <td class="text-center">
                  <p-button
                    text
                    size="small"
                    severity="danger"
                    title="Delete Gas Lift Valve"
                    icon="pi pi-trash"
                    (click)="onDeleteGlv(rIdx)"
                  ></p-button>
                </td>
              </tr>
            </ng-container>
          </ng-template>
        </p-table>
      </ng-container>
    </form>
  </app-tool-loader>
</div>
